export default __webpack_public_path__ + "static/hed-section-5-img-8cdaa20a71f1fc12e58308a10a027c09.png";